import { VerificationCriteriaParams, VerificationCriteriaStatus } from '@/backend/access/verificationCriteria/types';

export class VerificationCriteria {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  title: string;
  description: string;
  requirementId: string;
  propelOrgId: string;
  status: VerificationCriteriaStatus;

  constructor(params: VerificationCriteriaParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.title = params.title ?? '';
    this.description = params.description ?? '';
    this.requirementId = params.requirementId;
    this.propelOrgId = params.propelOrgId;
    this.status = params.status;
  }
}
